import ClientBase from "../ClientBase";

const BASE_URL = "api/v1/aiprojects";

class AiProjectClient extends ClientBase {

    // --- Roboflow browse ---
    async getAvailableRoboflowProjects() {
        return await this.get(`${BASE_URL}/available`) ?? [];
    }

    async getRoboflowProjectDetail(workspace, project) {
        return await this.get(`${BASE_URL}/available/${encodeURIComponent(workspace)}/${encodeURIComponent(project)}`);
    }

    // Workflows a project can run (base workflow + those referencing it).
    async getProjectWorkflows(id) {
        return await this.get(`${BASE_URL}/${id}/workflows`) ?? [];
    }

    // --- Register CRUD ---
    async getProjects() {
        return await this.get(BASE_URL) ?? [];
    }

    async getProject(id) {
        return await this.get(`${BASE_URL}/${id}`);
    }

    async createProject(request) {
        return await this.post(BASE_URL, request);
    }

    async updateProject(id, request) {
        return await this.put(`${BASE_URL}/${id}`, request);
    }

    async deleteProject(id) {
        return await this.delete(`${BASE_URL}/${id}`);
    }

    // --- Per-class run config ---
    async getProjectClasses(id) {
        return await this.get(`${BASE_URL}/${id}/classes`) ?? [];
    }

    async upsertProjectClass(id, request) {
        return await this.put(`${BASE_URL}/${id}/classes`, request);
    }
}

export default new AiProjectClient();
